// extracted by mini-css-extract-plugin
export default {"main":"price_main__KrOaF","price":"price_price__Pvpu0","pRange":"price_pRange__f3OzJ"};